module.exports = __webpack_public_path__ + "images/icons/flags/CN-0cf37634.svg";